import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CreditCard, Truck, Zap } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative pt-20 pb-20 md:pt-24 md:pb-32 overflow-hidden" data-id="element-134">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-zinc-800/40 via-brand-dark to-brand-dark -z-10" data-id="element-135" />
      <div className="absolute top-1/4 right-0 w-96 h-96 bg-brand-yellow/5 rounded-full blur-3xl -z-10" data-id="element-136" />

      <div className="container mx-auto px-4 md:px-6" data-id="element-137">
        <div className="max-w-4xl mx-auto text-center" data-id="element-138">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-surface border border-brand-border text-brand-yellow text-sm font-medium mb-8" data-id="element-139">
            <Zap className="w-4 h-4" data-id="element-140" />
            <span data-id="element-141">MEGA PACK MONOCICLO ELÉCTRICO</span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-5xl md:text-7xl font-bold mb-6 leading-tight" data-id="element-142">
            Todo el dominio de tu monociclo eléctrico.{' '}
            <span className="text-brand-yellow" data-id="element-143">Listo. Desde hoy.</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-xl md:text-2xl text-zinc-400 mb-10 max-w-2xl mx-auto" data-id="element-144">
            Mantenés, reparás y optimizás tu monociclo sin depender de un
            service.
          </motion.p>

          {/* Product Mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.25,
          ease: 'easeOut'
        }} className="mb-12" data-id="element-145">
            <img src="https://cdn.magicpatterns.com/uploads/kFX2qKEtscz8SaeeXZeG26/mockup_monociclo.png" alt="Mega Pack Monociclo Eléctrico — 6 Tomos + 6 Bonos" className="w-full max-w-xl mx-auto drop-shadow-[0_0_40px_rgba(250,204,21,0.15)]" data-id="element-146" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex flex-col items-center gap-6" data-id="element-147">
            <Button size="xl" withArrow className="animate-pulse-slow w-full sm:w-auto" onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-148">
              QUIERO MI MEGA PACK AHORA
            </Button>

            <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-sm text-zinc-500" data-id="element-149">
              <div className="flex items-center gap-2" data-id="element-150">
                <ShieldCheck className="w-4 h-4 text-brand-yellow" data-id="element-151" />
                <span data-id="element-152">Garantía 7 días</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-153">
                <CreditCard className="w-4 h-4 text-brand-yellow" data-id="element-154" />
                <span data-id="element-155">Pago seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-156">
                <Truck className="w-4 h-4 text-brand-yellow" data-id="element-157" />
                <span data-id="element-158">Entrega Inmediata</span>
              </div>
            </div>

            <p className="text-xs text-zinc-600 mt-2" data-id="element-159">
              Tarjeta / Transferencia / Mercado Pago
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}